export function getTranslator(translations, language) {
  return (key) => {
    const translation = translations.find(
      (translation) =>
        translation.language === language && translation.key === key
    );
    return translation ? translation.value : key;
  }
}